import React from "react";
import { Button, HStack, ButtonProps, StackProps } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";

interface ControlsProps extends Omit<StackProps, "children"> {
  children?: React.ReactNode | ((isSubmitting: boolean) => React.ReactNode);
  submitProps?: ButtonProps;
  submitText: React.ReactNode;
}

const Controls: React.FC<ControlsProps> = ({
  children,
  submitText,
  submitProps,
  ...rest
}) => {
  const {
    formState: { isSubmitting }
  } = useFormContext();

  return (
    <HStack spacing={4} justifyContent="flex-end" mt={4} {...rest}>
      {typeof children === "function" ? children(isSubmitting) : children}
      <Button {...submitProps} isLoading={isSubmitting} type="submit">
        {submitText}
      </Button>
    </HStack>
  );
};

export default Controls;
